import api from "./axiosInterceptor";

export const loginUser = ({ email, password }) => {
  return api.post("/accounts/api/access-token", {
    email,
    password,
  });
};

export const registerUser = (userInfo) =>
  api.post("/accounts/api/registration", userInfo);

export const refreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  return api.post("/accounts/api/refresh-token", {
    refreshToken,
  });
};

export const logoutUser = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  if(window.location.pathname !== '/login' && window.location.pathname !== '/register'){
    window.location.href = "/";
  }
};

export const userProfile = () => api.get("/accounts/api/user-profile");

export const companyDetails = (companyInfo) =>
  api.post("/accounts/api/company-setup", companyInfo);

export const updateCompanyDetails = (companyInfo) =>
  api.put("/accounts/api/company-setup", companyInfo);
